module.exports = __webpack_public_path__ + "img/image-02.e1cfb598.jpeg";